module.exports = __webpack_public_path__ + "img/img5.59febfa5.png";